import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomAlert from '../components/CustomAlert';
import useCustomAlert from '../hooks/useCustomAlert';

const styles = `
.info-button {
  display: inline-block;
  padding: 0.75rem 2rem;
  background-color: #4A8080;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
  text-decoration: none;
  margin-top: 2rem;
}

.info-button:hover {
  background-color: #3A6666;
}

.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.modal-close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 2rem;
  z-index: 10001;
  transition: opacity 0.3s;
}

.modal-close-btn:hover {
  opacity: 0.7;
}

.modal-nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 3rem;
  z-index: 10001;
  transition: opacity 0.3s;
  padding: 1rem;
}

.modal-nav-btn:hover {
  opacity: 0.7;
}

.modal-nav-btn.prev {
  left: 1rem;
}

.modal-nav-btn.next {
  right: 1rem;
}

.modal-image-container {
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: default;
}

.modal-image {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
}

.modal-caption {
  color: white;
  margin-top: 1rem;
  text-align: center;
  font-size: 1.125rem;
}


.festas-page {
  min-height: 100vh;
  background-color: white;
}

.festas-hero {
  padding: 4rem 0 3rem;
  background: linear-gradient(to bottom, #f0f9f9, white);
  position: relative;
}

.hero-banner {
  width: 40%;
  max-width: 1280px;
  margin: 0 auto 3rem;
  border-radius: 0.5rem;
  overflow: hidden;
}

.hero-banner img {
  width: 100%;
  height: auto;
  display: block;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
}

.festas-title {
  font-size: 3rem;
  color: #5A9C9C;
  text-align: center;
  margin-bottom: 2rem;
  font-weight: 300;
  letter-spacing: 0.025em;
}

.festas-intro {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
  color: #4A8080;
  line-height: 1.8;
  font-size: 1.125rem;
}

.festas-intro p {
  margin-bottom: 1rem;
}

.festas-highlight {
  font-weight: 600;
  color: #5A9C9C;
  font-size: 1.25rem;
  margin-top: 2rem;
}

.gallery-section {
  padding: 5rem 0;
  background-color: white;
  overflow: hidden;
}

.section-title {
  font-size: 2.5rem;
  color: #5A9C9C;
  text-align: center;
  margin-bottom: 10rem;
  font-weight: 300;
}

.gallery-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4rem 0;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(4, 150px);
  grid-template-rows: repeat(4, 150px);
  gap: 15px;
  transform: rotate(45deg);
  max-width: fit-content;
  margin: 0 auto;
}

.gallery-item {
  width: 150px;
  height: 150px;
  overflow: hidden;
  background-color: #f3f4f6;
  position: relative;
}

.gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: rotate(-45deg) scale(1.5);
  transform-origin: center;
  transition: transform 0.3s;
}

.gallery-item:hover img {
  transform: rotate(-45deg) scale(1.6);
}

.pacotes-section {
  padding: 5rem 0;
  background-color: #f0f9f9;
}

.pacotes-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.pacote-card {
  background-color: white;
  border-radius: 0.5rem;
  padding: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.pacote-card:hover {
  transform: translateY(-5px);
}

.pacote-card h3 {
  font-size: 1.75rem;
  color: #4A8080;
  margin-bottom: 1rem;
  text-align: center;
}

.pacote-price {
  font-size: 2rem;
  color: #5A9C9C;
  font-weight: 600;
  text-align: center;
  margin-bottom: 1.5rem;
}

.pacote-features {
  list-style: none;
  padding: 0;
  margin: 0 0 2rem 0;
}

.pacote-features li {
  padding: 0.75rem 0;
  color: #4b5563;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.pacote-features li:before {
  content: "✓";
  color: #5A9C9C;
  font-weight: bold;
  font-size: 1.25rem;
}

.pacote-btn {
  width: 100%;
  padding: 1rem;
  background-color: #4A8080;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.pacote-btn:hover {
  background-color: #3A6666;
}

.info-section {
  padding: 5rem 0;
  background-color: white;
}

.info-content {
  max-width: 900px;
  margin: 0 auto;
  color: #4b5563;
  line-height: 1.8;
}

.info-content h3 {
  font-size: 1.5rem;
  color: #5A9C9C;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.info-content ul {
  list-style: disc;
  margin-left: 2rem;
  margin-bottom: 1.5rem;
}

.info-content li {
  margin-bottom: 0.5rem;
}

.contact-section {
  padding: 5rem 0;
  background-color: #4A8080;
  color: white;
}

.contact-container {
  max-width: 48rem;
  margin: 0 auto;
  padding: 0 1rem;
  text-align: center;
}

.contact-title {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-weight: 300;
}

.contact-subtitle {
  font-size: 1.125rem;
  margin-bottom: 3rem;
  opacity: 0.9;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  text-align: left;
}

.form-group label {
  font-size: 0.875rem;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 0.875rem;
  background-color: #5A9C9C;
  border: 1px solid #4A8080;
  border-radius: 0.375rem;
  color: white;
  font-family: inherit;
  font-size: 1rem;
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: white;
}

.submit-btn {
  width: 100%;
  padding: 1rem;
  background-color: white;
  color: #4A8080;
  border: none;
  border-radius: 0.375rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
  font-size: 1rem;
}

.submit-btn:hover {
  background-color: #f3f4f6;
}

@media (max-width: 768px) {
  .festas-title {
    font-size: 2rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .gallery-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .pacotes-grid {
    grid-template-columns: 1fr;
  }

  .contact-title {
    font-size: 2rem;
  }
}

@media (max-width: 480px) {
  .gallery-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
`;

function ImageModal({ isOpen, onClose, images, currentIndex, onNext, onPrev }) {
  if (!isOpen) return null;
  

  return (
    <div className="image-modal" onClick={onClose}>
      <button onClick={onClose} className="modal-close-btn">×</button>

      <button
        onClick={(e) => {
          e.stopPropagation();
          onPrev();
        }}
        className="modal-nav-btn prev"
      >
        ‹
      </button>

      <div className="modal-image-container" onClick={(e) => e.stopPropagation()}>
        <img
          src={typeof images[currentIndex] === 'string' ? images[currentIndex] : images[currentIndex].src}
          alt={typeof images[currentIndex] === 'string' ? `Imagem ${currentIndex + 1}` : images[currentIndex].alt}
        />

        {images[currentIndex].caption && (
          <p className="modal-caption">{images[currentIndex].caption}</p>
        )}
      </div>

      <button
        onClick={(e) => {
          e.stopPropagation();
          onNext();
        }}
        className="modal-nav-btn next"
      >
        ›
      </button>
    </div>
  );
}

export default function FestasAniversarioPage() {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const { alertProps, showSuccess } = useCustomAlert();

  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    mensagem: ''
  });

  const openModal = (index) => {
    setCurrentImageIndex(index);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Pedido enviado:', formData);
    showSuccess('Pedido enviado com sucesso! Entraremos em contacto em breve.');
  };

  const galleryImages = [
    { src: '/assets/gallery/image.png', alt: 'Festa 1' },
    { src: '/assets/gallery/image2.png', alt: 'Festa 2' },
    { src: '/assets/gallery/image3.png', alt: 'Festa 3' },
    { src: '/assets/gallery/image4.png', alt: 'Festa 4' },
    { src: '/assets/gallery/image5.png', alt: 'Festa 5' },
    { src: '/assets/gallery/image6.png', alt: 'Festa 6' },
    { src: '/assets/gallery/image7.png', alt: 'Festa 7' },
    { src: '/assets/gallery/image8.png', alt: 'Festa 8' },
    { src: '/assets/gallery/image9.png', alt: 'Festa 9' },
    { src: '/assets/gallery/image10.png', alt: 'Festa 10' },
    { src: '/assets/gallery/image11.png', alt: 'Festa 11' },
    { src: '/assets/gallery/image12.png', alt: 'Festa 12' },
    { src: '/assets/gallery/image13.png', alt: 'Festa 13' },
    { src: '/assets/gallery/image14.png', alt: 'Festa 14' },
    { src: '/assets/gallery/image15.png', alt: 'Festa 15' }
  ];


  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  return (
    <>
      <style>{styles}</style>
      <div className="festas-page">
        <section className="festas-hero">
          <div className="hero-banner">
            <img src="/assets/image13.png" alt="Festas Aniversário" />
          </div>
          <div className="container">
            <h1 className="festas-title">Festas Aniversário</h1>
            <div className="festas-intro">
              <p className="festas-highlight">Festejamos juntos!</p>
              <p>
                Vem festejar com os teus amigos um dia especial!
              </p>
              <p>
                No Barco de Papel proporcionamos festas de aniversário únicas e memoráveis,
                onde a criatividade e a diversão são os ingredientes principais!
              </p>
              
              <button 
                className="info-button"
                onClick={() => navigate('/info-festas-de-aniversário')}
              >
                + info ›
              </button>
            </div>
          </div>
        </section>

        <section className="gallery-section">
          <div className="container">
            <h2 className="section-title">Momentos Especiais</h2>
            <div className="gallery-grid">
              {galleryImages.map((img, index) => (
                <div key={index} className="gallery-item" onClick={() => openModal(index)}>
                  <img src={img.src} alt={`Festa ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="contact-section">
          <div className="contact-container">
            <h2 className="contact-title">Contato</h2>
            <p className="contact-subtitle">
              Gostou do que viu? Contacte-nos para saber mais.
            </p>

            <div className="contact-form">
              <div className="form-group">
                <label>Nome *</label>
                <input
                  type="text"
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  placeholder="Insira seu nome"
                />
              </div>

              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Insira seu email"
                />
              </div>

              <div className="form-group">
                <label>Telefone</label>
                <input
                  type="tel"
                  name="telefone"
                  value={formData.telefone}
                  onChange={handleChange}
                  placeholder="Insira seu telefone"
                />
              </div>

              <div className="form-group">
                <label>Mensagem</label>
                <textarea
                  name="mensagem"
                  value={formData.mensagem}
                  onChange={handleChange}
                  placeholder="Conte-nos sobre a festa dos seus sonhos..."
                  rows="5"
                />
              </div>

              <button type="button" onClick={handleSubmit} className="submit-btn">
                Enviar Pedido
              </button>
            </div>
          </div>
          <CustomAlert {...alertProps} />
        </section>
        <ImageModal
        isOpen={modalOpen}
        onClose={closeModal}
        images={galleryImages}
        currentIndex={currentImageIndex}
        onNext={nextImage}
        onPrev={prevImage}
      />
      </div>
    </>
  );
}